import React from 'react';

import { Layout, Result } from 'antd';

export function ExpiredInvite() {
    return (
        <Layout
            data-component="ExpiredInvite"
            style={{ 
                minHeight: '100vh', 
                alignItems: 'center', 
                justifyContent: 'center'
            }}
        >
            <Result
                status="404"
                title="Convite expirado"
                subTitle="Este convite está expirado e não aceita mais inscrições."
            />
        </Layout>
    );
}

